import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=319f3f1a&scoped=true&"
var script = {}
import style0 from "./Splash.vue?vue&type=style&index=0&id=319f3f1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319f3f1a",
  null
  
)

export default component.exports